import React from 'react';
import Modal from 'react-responsive-modal';

import KatottgTree from './KatottgTree';
import { getDefinedItem } from '../../util/tools';

import hierarchyIcon from '../../assets/icons/png24x24/Hierarchy.png';

class KatottgButton extends React.Component {

	/*
		props:
			onKatottgSelected
			styles
				button
	*/	
	constructor(props) {
		super(props);
		this.refKatottg = React.createRef();
		this.state = {
			isModalOpen: false
		}
	}
	
	openModal = () => {
		this.setState({isModalOpen: true});
	}
	closeModal = () => {
		this.setState({isModalOpen: false});
	}
	select = () => {
		let code = this.refKatottg.current.state.selectedCode;
		this.props.onKatottgSelected( code );
		this.closeModal();
	}
	
	render() {
		let styleButton = Object.assign(
				{}, 
				getDefinedItem(this.props, ['styles', 'button']));
		
		return (
			<React.Fragment>
				<button type='button' style={styleButton} onClick={this.openModal}>
					<img src={hierarchyIcon} />
				</button>
				<Modal 
					open={this.state.isModalOpen} 
					onClose={this.closeModal} center 
					styles={styleModal}
					closeOnOverlayClick={false} animationDuration={1}
				>
						<div style={{fontSize: '16pt', textAlign: 'center', padding: '10px', borderRadius: '21px 21px 0 0', backgroundColor: '#F0F0F0'}}>
							КАТОТТГ
						</div>
						<div style={{margin: '15px', padding: '10px', overflow: 'scroll', height: '450px', border: '1px solid blue'}}>
							<KatottgTree ref={this.refKatottg} />
						</div>
						<div style={{textAlign: 'right', marginRight: '15px'}}>
							<button type='button' onClick={this.select} style={{padding: '3px 10px 3px 10px'}}>Вибрати</button>
						</div>
				</Modal>
			</React.Fragment>
		);
	}
}

const styleModal = {
	modal: {
		background: '#ffffff',
		padding: '0px',
		borderRadius: '21px',
		maxWidth: '500px',
		width: '100%',
		height: '600px'
	},
	closeButton: {
		top: '10px',
		right: '10px',
		fill: '#FF0000',
		outline: 'none',
	},
};

export default KatottgButton;